import { TMeasurementSection } from '@/components/measurementSection/types'

import { SelectButton } from './subcomponents'

export const MeasurementSection = ({
  changeLeftMeasurement,
  changeRightMeasurement,
  isActiveLeft,
  leftName,
  rightName,
}: TMeasurementSection) => {
  return (
    <div className="measurement-section">
      <SelectButton isActive={isActiveLeft} direction="left" onClick={changeLeftMeasurement}>
        {leftName}
      </SelectButton>
      <SelectButton isActive={!isActiveLeft} direction="right" onClick={changeRightMeasurement}>
        {rightName}
      </SelectButton>
    </div>
  )
}
